// extracted by mini-css-extract-plugin
export default {"cta":"_U-z","disabled":"aV-z"};